// extracted by mini-css-extract-plugin
module.exports = {"container":"Components_container__khTrP","navTitle":"Components_navTitle__2Rd4o","navIcon":"Components_navIcon__1NyNU"};